/* eslint-disable no-use-before-define */
import './slick.js';

var already_loaded = false;

$(window).on('load', function(){ 
  already_loaded = true;
});

$(function() {

  

  

  if(already_loaded) {
    init_sliders();
    display_splash();
  } else {
    $(window).on('load', function(){
      init_sliders();
      display_splash();
    });
  }

  function display_splash() {
    var cookie_value = getCookie('splashscreen');

    if(cookie_value == 'true') {
      $('.splash-screen').remove();
      
    }
  
    setCookie('splashscreen', 'true', 1);
  
    $('.splash-screen__logo').addClass('splash-screen__logo--show');
  
    setTimeout(function(){
      $('.splash-screen').addClass('splash-screen--fade-out');
    }, 1500);
  
    setTimeout(function(){
      $('.splash-screen').remove();
    }, 2000);
  }
  
  function setCookie(name,value,days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
  }

  function getCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }


  function init_sliders() {
    $('.top-banner__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      fade: true,
      infinite: true,
      speed: 300,
      centerMode: false,
      variableWidth: false,
      arrows: false,
      dots: true,
    });

    $('.feature__slider').each(function(){
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        fade: true,
        infinite: true,
        speed: 300,
        centerMode: false,
        variableWidth: false,
        arrows: true,
      });
    });
  }

  $(document).on('click','[data-open-nav]', function() {
    $('.hamburger').addClass('hamburger--open');
    $('.header').addClass('header--open');
    $('.mobile-nav').addClass('mobile-nav--open');
    $('.overlay').addClass('overlay--shown');
  });

  $(document).on('click','[data-close-nav]', function() {
    close_menu();
  });

  function close_menu() {
    $('.hamburger').removeClass('hamburger--open');
    $('.header').removeClass('header--open');
    $('.mobile-nav').removeClass('mobile-nav--open');
    $('.overlay').removeClass('overlay--shown');
  }

  $(document).on('click','[data-toggle-nav]', function() {
    $('.hamburger').toggleClass('hamburger--open');
    $('.header').toggleClass('header--open');
    $('.mobile-nav').toggleClass('mobile-nav--open');
    $('.overlay').toggleClass('overlay--shown');
  });

  $(document).on('click','.overlay', function() {
    $('.hamburger').removeClass('hamburger--open');
    $('.header').removeClass('header--open');
    $('.mobile-nav').removeClass('mobile-nav--open');
    $('.overlay').removeClass('overlay--shown');
  });

   //open popup
   $(document).on('click', '[data-open-popup]', open_popup);

   function open_popup(event){
     event.preventDefault();
 
     $('.popup').addClass('popup--shown');
     $('.overlay').addClass('overlay--black');
     $('.overlay').addClass('overlay--shown');

     var slide = $(this).data('gallery-slide');

     $('.gallery-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      fade: true,
      infinite: true,
      speed: 300,
      centerMode: true,
      variableWidth: false,
      variableHeight: false,
      arrows: true,
      appendArrows: $('.gallery-slider__img-wrap'),
    });

    $('.gallery-slider').slick('slickGoTo', slide, true);

    $(document).on('click','.gallery-slider .slick-prev', function() {
      $('.gallery-slider').slick('slickPrev');
    });

    $(document).on('click','.gallery-slider .slick-next', function() {
      $('.gallery-slider').slick('slickNext');
    });


    $(window).on('resize', function() {
      setTimeout(function(){
        reset_close_position();
      }, 100);
      
    });

    setTimeout(function(){
      reset_close_position();
    }, 100);
   }
   

   function reset_close_position() {
  
    var image_width = $('.gallery-slider__img').width();
    var image_height = $('.gallery-slider__img').height();


    if( window.matchMedia('(min-width: 800px)').matches ){
      $('.popup__close').css('right', 'calc(50% - ('+image_width+'px / 2) + 20px)');
    } else {
      $('.popup__close').css('right', 'calc(50% - ('+image_width+'px / 2) + 10px)');
    }

    $('.popup__background').css('width', image_width+'px');
    $('.popup__background').css('height', image_height+'px');
   }
 
   //close-popup
   $(document).on('click', '[data-close-popup]', close_popup);
 
   function close_popup(){
     $('.overlay').removeClass('overlay--shown');
     $('.overlay').removeClass('overlay--black');
     $('.popup').removeClass('popup--shown');

     $('.gallery-slider').slick('unslick')
   }

   $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - 70;

    close_menu();

    $('html, body').animate({scrollTop:position}, speed, 'swing');
    return false;
  });


  // $('.header__logo').click(function(){
  //   close_menu();
  //   $('html, body').animate({scrollTop:0}, 500, 'swing');
  // })

  $(document).on('click', '.gallery-slider__slide', function(e){
    if($(e.target).hasClass('gallery-slider__slide')){
      close_popup();
    }
  })
});


////////////////////////////////// Animation triggers /////////////////////////////////////////
var items_to_animate = [].slice.call(document.querySelectorAll('[data-animate]'));

if ('IntersectionObserver' in window) {
  var configAnimation = {
    // If the element gets within 400px in the Y axis, start the animation.
    rootMargin: '0px 0px -50% 0px',
    threshold: 0.01,
  };

  let animation_observer = new IntersectionObserver(function on_intersection(entries){
    entries.forEach(function(entry) {

      //we check the type of animation to see if it should only triggered once or not
      var animation_type = entry.target.dataset.animate;

      if (entry.isIntersecting) {
        //element is in the view so we start the animation

        setInterval(function(){
          entry.target.classList.toggle('animated');
        }, 3000);


        //If the animation should be done only once, remove the observer
        if(animation_type == 'once')
        {
          animation_observer.unobserve(entry.target);
        }
      }else{

        if( animation_type != 'once'){
          //If the animation have to be triggered again
          entry.target.classList.remove('animated');
        }
      }

    });
  }, configAnimation);

  items_to_animate.forEach(function(item_to_animate) {
    animation_observer.observe(item_to_animate);
  });
}else{
  //fallback
  items_to_animate.forEach(function (item_to_animate){
    setInterval(function(){
      item_to_animate.classList.toggle('animated');
    }, 3000);
  })
}


// WEBPACK FOOTER //
// ./scripts/main.js